export const PROMPT_STATUS = {
  PUBLIC: "Public",
  PRIVATE: "Private",
} as const;

export const CHIP_COLORS = {
  PUBLIC: {
    light: "bg-brand-primary text-white",
    dark: "bg-brand-primary text-white",
  },
  PRIVATE: {
    light: "border-brand-primary text-brand-primary",
    dark: "border-white text-white",
  },
} as const;

export const DEFAULT_MAX_CONTENT_LENGTH = 150;
export const DEFAULT_EXPANDED_HEIGHT = 100;
export const MIN_EXPANDED_HEIGHT = 100;
export const MAX_EXPANDED_HEIGHT = 400;
